export const requestFullscreen = (element: HTMLElement = document.documentElement) => {
    if ('requestFullscreen' in element) {
        element.requestFullscreen().catch(() => {});
        return;
    }
    if ('webkitRequestFullscreen' in element) {
        try {
            (element as any).webkitRequestFullscreen();
        } catch (e) {
            /* ignore fullscreen error */
        }
    }
};

export const exitFullscreen = () => {
    if ('exitFullscreen' in document) {
        document.exitFullscreen();
        return;
    }
    if ('webkitExitFullscreen' in document) {
        (document as any).webkitExitFullscreen();
    }
};

export const isFullscreenActive = () =>
    Boolean(document.fullscreenElement || (document as any).webkitFullscreenElement);
